// extracted by mini-css-extract-plugin
export var container = "_9q-0";
export var icon = "_9q-1";
export var text = "_9q-2";